import { Flex, Tooltip } from 'antd';
import { CrownOutlined, ThunderboltOutlined } from '@ant-design/icons';
import React, { FunctionComponent } from 'react';
import { useStore } from '../../helpers/use-store';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

const VideoCredits: FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    dataStore: { userStore },
  } = useStore();

  const subscriptionCredits = Math.floor(userStore.userSubscription.credits);
  const topupCredits = Math.floor(userStore.userSubscription.topupCredits || 0);

  return (
    <Flex
      justify={'center'}
      align={'center'}
      gap={0}
      style={{ flexDirection: 'column' }}
    >
      <Flex gap={10} className="subscription-info-item">
        <div>
          <Tooltip title={t('videoCredits.subscriptionCredits')}>
            <span style={{ marginRight: '5px' }}>{subscriptionCredits}</span>
            <CrownOutlined />
          </Tooltip>
        </div>
        {topupCredits > 0 && (
          <div>
            <Tooltip title={t('videoCredits.topupCredits')}>
              <span style={{ marginRight: '5px', color: '#eb2f96' }}>
                +{topupCredits}
              </span>
              <ThunderboltOutlined style={{ color: '#eb2f96' }} />
            </Tooltip>
          </div>
        )}
      </Flex>
    </Flex>
  );
};

export default observer(VideoCredits);
